'use client';

import { ButtonHTMLAttributes, FC, ReactNode } from 'react';
import styles from './PrimaryButton.module.scss';
interface PrimaryButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary';
  iconLeft?: ReactNode;
}
const PrimaryButton: FC<PrimaryButtonProps> = ({
  variant = 'primary',
  iconLeft,
  className,
  children,
  type = 'button',
  ...rest
}) => {
  const cls = [styles.btn, variant === 'secondary' ? styles.secondary : '', className || ''].filter(Boolean).join(' ');
  return <button type={type} className={cls} {...rest} data-sentry-component="PrimaryButton" data-sentry-source-file="PrimaryButton.tsx">
            {iconLeft && <span className={styles.iconLeft}>{iconLeft}</span>}
            {children}
        </button>;
};
export default PrimaryButton;